import { Provider } from 'react-redux';
import localFont from 'next/font/local';
import { config } from '@fortawesome/fontawesome-svg-core';
import store from '../store';
import PwaManager from '../components/pwa/PwaManager';
import InstallPrompt from '../components/pwa/InstallPrompt';
import BottomNav from '../components/pwa/BottomNav';
import useStandalone from '../components/pwa/useStandalone';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-svg-core/styles.css';
import '../components/styles/main.styles.css';

// FontAwesome injecteaza CSS-ul la runtime (autoAddCss), dar CSP-ul blocheaza
// <style>-ul inline -> iconitele fara width/height raman la dimensiunea intrinseca
// a SVG-ului (uriase). CSS-ul vine din bundle (style-src 'self'), injectarea e oprita.
config.autoAddCss = false;

const montserrat = localFont({
  src: [
    { path: '../public/fonts/Montserrat-Light.ttf',    weight: '300', style: 'normal' },
    { path: '../public/fonts/Montserrat-Regular.ttf',  weight: '400', style: 'normal' },
    { path: '../public/fonts/Montserrat-Medium.ttf',   weight: '500', style: 'normal' },
    { path: '../public/fonts/Montserrat-SemiBold.ttf', weight: '600', style: 'normal' },
    { path: '../public/fonts/Montserrat-Bold.ttf',     weight: '700', style: 'normal' },
  ],
  variable: '--font-montserrat',
  display: 'swap',
});

function AppShell({ Component, pageProps }) {
  const standalone = useStandalone();
  // În app-ul instalat lăsăm loc pentru bara de jos (+ safe-area).
  const style = standalone
    ? { height: '100%', paddingBottom: 'calc(58px + env(safe-area-inset-bottom))' }
    : { height: '100%' };

  return (
    <div className={montserrat.variable} style={style}>
      <Component {...pageProps} />
      <PwaManager />
      <InstallPrompt />
      <BottomNav />
    </div>
  );
}

function MyApp(props) {
  return (
    <Provider store={store}>
      <AppShell {...props} />
    </Provider>
  );
}

export default MyApp;
